Auth = require 'app/scripts/db/auth'
React = require 'react'
l = require 'app/scripts/lib/localize'
t = require('app/scripts/views/internal/recup-with-helpers')('invite_acceptance_notification')
{ trackUe } = require '@trello/analytics'
_ = require 'underscore'

module.exports = class InviteAcceptanceNotification extends React.Component
  constructor: (props) ->
    super(props)
    @state = {
      members: props.members
    }

  getTitle: ->
    if @state.members.length == 1
      t.text "#{@state.members[0].get('fullName')} "
      t.format "joined your board"
    else
      t.format "new members joined your board"

  getBody: ->
    numberOfMembers = @state.members.length
    memberNames = []
    if numberOfMembers == 1
      memberNames = _.map @state.members, (member) ->
        if member.get('fullName')?
          tokens = member.get('fullName').split " "
          if tokens.length > 0
            tokens[0]
    else
      memberNames = _.map @state.members, (member) -> member.get 'fullName'

    # First sentence
    if numberOfMembers == 1
      t.text memberNames[0] + " "
      t.format "is new to trello"

    else if numberOfMembers == 2
      t.text memberNames[0] + " "
      t.format "and"
      t.text " " + memberNames[1] + " "
      t.format "are new to trello"

    else if numberOfMembers == 3
      t.text memberNames[0] + ", "
      t.text memberNames[1] + ", "
      t.format "and"
      t.text " "
      t.text memberNames[2] + " "
      t.format "are new to trello"

    else
      names = ""
      memberNames
        .slice(0, 3)
        .forEach (memberName) -> names += memberName + ", "
      t.text names
      t.format "and"
      t.text " "
      t.text numberOfMembers - 3 + " "
      if numberOfMembers == 4
        t.format "other are new to trello"
      else
        t.format "others are new to trello"

    t.text " "

    # Second sentence
    if numberOfMembers == 1
      t.a { href: "https://trello.com/guide/feature-deep-dive" , target: "_blank" , onClick: @clickAddCardLink }, ->
        t.format "help them get started by adding them to a card"
    else
      t.a { href: "https://trello.com/guide/feature-deep-dive" , target: "_blank" , onClick: @clickAddCardLink }, ->
        t.format "help your board members get started by adding them to a card"

    t.text " "

    # Third sentence
    t.a { href: "https://trello.com/guide/collaboration" , target: "_blank" , onClick: @clickMentionLink }, ->
      if numberOfMembers == 1
        t.format "you can mention them sg in a comment too"
      else
        t.format "you can mention them pl in a comment too"

  clickAddCardLink: ->
    trackUe('invite acceptance notification', 'click', 'help adding them to a card', '', '', '', { member: Auth.me().id })

  clickMentionLink: ->
    trackUe('invite acceptance notification', 'click', 'help mentioning them', '', '', '', { member: Auth.me().id })

  clickDontShowAgain: =>
    Auth.me().dismiss('notify-invite-acceptance')
    trackUe('invite acceptance notification', 'dismiss', 'future notifications',
      '', '', 'by clicking dont show again', { member: Auth.me().id })
    @props.onClose()

  render: t.renderable ->
    t.div '.invite-acceptance-notification', =>
      t.div '.invite-acceptance-notification-close', =>
        t.a { onClick: @props.onClose, href: '#' }, ->
          t.span '.icon-lg.icon-close'
      t.h6 =>
        @getTitle()
      t.p =>
        @getBody()
      t.div '.invite-acceptance-notification-dont-show-again', =>
        t.a { onClick: @clickDontShowAgain, href: '#' }, ->
          t.text "Don't show this again"
